import {
  PlacementProps,
  RenderLabelProps,
  ShouldRenderType,
} from 'components/Placement/types';
import PlacementViewStatsTable from '../StatsTable/StatsTable';
import { getCpm, mergeRollupMetricSummaries } from '../utils';
import PlacementViewAttributes from '../Attributes/Attributes';
import { QualitySection } from './QualitySection';

type QualityStatsAttrSectionProps = {
  cbn: string;
  shouldRender: ShouldRenderType;
  placement: PlacementProps;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  reportingWindow: any;
  renderLabel: RenderLabelProps;
};

export function QualityStatsAttrSection({
  cbn,
  shouldRender,
  placement,
  reportingWindow,
  renderLabel,
}: Readonly<QualityStatsAttrSectionProps>) {
  const {
    attributes,
    durationLength,
    mediaValues,
    placedBy,
    method,
    quality,
    source,
    integration,
    verbalMentions,
    rollupMetricSummary: placementRollupMetricSummary,
  } = placement;
  const { channel } = source?.production ?? integration?.production ?? {};
  const rollupMetricSummary = mergeRollupMetricSummaries(
    placementRollupMetricSummary,
    source?.rollupMetricSummary,
  );

  // Calculating earned CPM, if we have it.
  const live7impressions = rollupMetricSummary.find(
    (row) => row.reportingWindow === 'live7',
  );
  const cpm = getCpm(live7impressions, mediaValues);

  return (
    <>
      {shouldRender('qualitySection') && (
        <>
          <div className={`${cbn}__content__block__title`}>
            <QualitySection shouldRender={shouldRender} quality={quality} />
          </div>
          <div className={`${cbn}__content`}>
            {shouldRender('qualitySection.statsTable') && (
              <PlacementViewStatsTable
                channelName={channel?.name}
                durationLength={durationLength}
                mediaValues={mediaValues}
                placedBy={placedBy}
                method={method}
                reportingWindow={reportingWindow}
                cpm={cpm}
                renderLabel={renderLabel}
                shouldRender={shouldRender}
                verbalMentions={verbalMentions}
              />
            )}
          </div>
        </>
      )}
      {shouldRender('qualitySection.attributes') && (
        <div className={`${cbn}__content`}>
          <PlacementViewAttributes attributes={attributes} />
        </div>
      )}
    </>
  );
}
